<template>
	<div>
		<div class="card">
			<div class="card-header">
				<div class="row">
					<div class="col-6">
						<h3>Legal disclosure</h3>
					</div>
					<div class="col-5" v-if="f.showSign==1 && f.showSignCustomer==1">
							<button type="submit" class="btn btn-success float-right" @click="saveSettingSign()">
								Save
							</button>
							<button type="button" class="btn btn-white float-right" @click="CancelClose()">
								Cancel
							</button>
						</div>
				</div>
			</div>
			<div class="card-body">
				<form @submit.prevent="saveSettingSign">
					<div class="form-row">
						<div class="col-12">
							<label class="radio-inline col-6"><h4>Add signature to my contracts:</h4></label>
							<label class="radio-inline col-2">
								<span class="form-text showSign">
									Enable </span
								>
								<input
									type="radio"
									value="1"
									v-model="f.showSign"
								/>
							</label>
							<label class="radio-inline col-2">
								<span class="form-text showSign">
									Disable </span
								>
								<input type="radio" value="0" v-model="f.showSign" />
							</label>
						</div>
					</div>
					<div class="form-row" v-if="f.showSign==1">
						<div class="col-12">
							<hr>
							<div class="form-row">
								<div class="col-6">
									<span class="form-text">Your signature:</span>
									<input
										type="text"
										class="form-control"
										v-model="f.signature"
										required
									/>
								</div>
								<div class="col">
									<span id="" class="form-text"
										>Font style:</span
									>
									<select id="fontStyle" class="form-control" v-model="f.fontStyle" @change="changeFontStyle">
										<option value="0">Normal</option>
										<option value="1">Grand Amoura</option>
										<option value="2">Malina</option>
										<option value="3">Olivia</option>
										<option value="4">Playlist</option>
										<option value="5" selected="selected">Signatrue</option>
										<option value="6">Variane Script</option>
									</select>
								</div>
							</div>
						</div>
						<div class="col-12">
							<div id="previewSign" class="fontStyle5" >{{f.signature}}</div>
							<hr>
						</div>
						<div class="col-12">
							<label class="radio-inline col-6"><h4>Enable signature for customers:</h4></label>
							<label class="radio-inline col-2">
								<span class="form-text showSign">
									Enable </span
								>
								<input
									type="radio"
									value="1"
									v-model="f.showSignCustomer"
								/>
							</label>
							<label class="radio-inline col-2">
								<span class="form-text showSign">
									Disable </span
								>
								<input type="radio" value="0" v-model="f.showSignCustomer" />
							</label>
						</div>
					</div>
					<div class="form-row"  v-if="f.showSign==1 && f.showSignCustomer==1">
						<div class="col-12">
							<div class="form-row">
								<div class="col-6">
									<span class="form-text">Contact E-Mail:</span>
									<input
										type="text"
										class="form-control"
										v-model="f.emailContact"
										required
									/>
								</div>
								<div class="col-6">
									<span class="form-text">Telephone Contact:</span>
									<input
										type="text"
										class="form-control"
										v-model="f.phoneContact"
										required
									/>
								</div>
								<div class="col-6">
									<span class="form-text">Copy Cost Per Page:</span>
									<input
										type="text"
										class="form-control"
										v-model="f.copycostperpage"
										required
									/>
								</div>
							</div>
						</div>
						<div class="col-12" style="margin: 20px 0px;">
							<div class="alert alert-info alert-dismissible fade show" role="alert" v-if="showNote">
								<button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="showNote=!showNote">
							    <span aria-hidden="true">&times;</span>
							  </button>
							  <p><b class="alert-heading">Note:</b> This is a disclosure agreement between two or more parties to acknowledge the digital signing of document between them. Marketea billing provides a default disclosure agreement which can also be customised based on organizational needs. The data marked or enclosed between $[ ... ] will be replaced by the upper fields when saving the document, if you want to edit it, apply the direct changes in the upper editing fields for more comfort.</p>
							</div>
							<span id="" class="form-text">
								<span class="badge badge-pill badge-info" v-if="!showNote" @click="showNote=!showNote"><i class="fa fa-info"></i></span>
								Terms and conditions:
								<span class="badge badge-pill badge-dark float-right" @click="termCondDefault()">Use default formatting</span>
							</span>
						</div>
						<div class="col-12" >
							<vue-editor
								id="editor"
								:editor-toolbar="customToolbar"
								v-model="f.termsConditions"
								style="width: 100%"
							/>
						</div>
					</div>
					<div class="form-row buttons" >
						<div class="col-12">
							<button type="submit" class="btn btn-success float-right">
								Save
							</button>
							<button type="button" class="btn btn-white float-right" @click="CancelClose()">
								Cancel
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
		<link rel="stylesheet" :href="urlmaster+'css/firmas.css'"/>
	</div>
</template>
<script>
import { VueEditor } from 'vue2-editor'
export default {
	components: {
		VueEditor,
	},
	name: "signature",
	data () {
		return {
			urlmaster: window.urlmaster,
			m: {
				show: false,
				component: '',
				data: []
			},
			f: {
				user_id: window.master_client,
				org_id: window.localorgdata,
				id: 0,
				signature: '',
				fontStyle: 5,
				termsConditions: "",
				showSign: 0,
				showSignCustomer: 0,
				emailContact: '',
				phoneContact: '',
				copycostperpage: 0,
			},
			termsConditionsDefaul: "<p><strong>ELECTRONIC RECORD AND SIGNATURE DISCLOSURE</strong></p><p><br></p><p>Please read the following information carefully. By clicking the 'I agree' button, you agree that you have reviewed the following terms and conditions and consent to transact business electronically using Marketea billing electronic signature system. If you do not agree to these terms, do not click the 'I agree' button.</p><p><br></p><p><strong>Electronic documents</strong></p><p><br></p><p>Please note that $[Organization] will send all documents electronically to you to the email address or phone number that you have given us during the course of the business relationship unless you tell us otherwise in accordance with the procedure explained herein. Once you sign a document electronically, we will send a PDF version of the document to you.</p><p><br></p><p><strong>Request for paper copies</strong></p><p><br></p><p>You have the right to request from us paper copies of the documents that are sent to you electronically. You have the ability to download and print documents that are sent to you electronically. If you wish to receive paper copies of the documents that we have sent to you electronically, you can send an email to $[ContactE-Mail] or phone number $[TelephoneContact]. We will charge $[CopyCostPerPage] per page for sending the documents as paper copies.</p><p><br></p><p><strong>Withdrawing your consent</strong></p><p><br></p><p>At any point in time during the course of our business relationship, you have the right to withdraw your consent to receive documents in electronic format. If you wish to withdraw your consent, you can decline to sign a document that we have sent to you and send an email to $[ContactE-Mail] or phone number $[TelephoneContact] informing us that you wish to receive documents only in paper format. Upon request from you, we will stop sending documents using Marketea billing electronic signature system.</p><p><br></p><p><strong>To advise $[Organization] of your new email address or phone number</strong></p><p><br></p><p>If you need to change the email address that you use to receive notices and disclosures from us, write to us at $[ContactE-Mail] or phone number $[TelephoneContact]</p><p><br></p><p><strong>System requirements</strong></p><p><br></p><p>Compatible with recent versions of popular browsers such as Chrome, Firefox, Safari, Edge and Internet Explorer.</p><p><br></p>",
            customToolbar: [
                [{ header: [false, 1, 2, 3, 4, 5, 6] }],
                ["bold", "italic", "underline", "strike"], // toggled buttons
                [
                    { align: "" },
                    { align: "center" },
                    { align: "right" },
                    { align: "justify" }
                ],
                ["blockquote", "code-block"],
                [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
                [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
                [{ color: [] }, { background: [] }], // dropdown with defaults from theme
                // ["link", "image", "video"],
                ["link"],
                ["clean"] // remove formatting button
            ],  
            showNote: true,
            fullname: '',
			emailContact: '',
			phoneContact: '',
		}
	},
	created () {
		this.init();
	},
	methods: {
		init() {
			let t = this;
			t.f.termsConditions = t.termsConditionsDefaul;
			t.getCompanyInfo();
		},
		termCondDefault(){
			let t = this;
			t.$swal({
				title: "Use default format?",
				text: "Sure you want to replace the current text with the default format?",
				icon: "warning",
				showCancelButton: true,
				confirmButtonColor: "#3085d6",
				confirmButtonText: "Yes apply it!",
			}).then((result) => {
				if (result.value) {
					t.f.termsConditions=t.termsConditionsDefaul
				}
			});
		},
		changeFontStyle(){
			let t = this;
			let previewSign = document.querySelector("#previewSign");
			previewSign.removeAttribute('class');
			previewSign.classList.add('fontStyle'+t.f.fontStyle);
			t.$store.commit("core/setLoadingModal", true);
			setTimeout(function(){
				t.$store.commit("core/setLoadingModal", false);
			}, 1000);
		},
		CancelClose(){
			let t = this;
			t.f.id= 0;
			t.f.signature= '';
			t.f.fontStyle= 5;
			t.f.termsConditions= "";
			t.f.showSign= 0;
			t.f.showSignCustomer= 0;
			t.f.emailContact= '';
			t.f.phoneContact= '';
			t.f.copycostperpage= 0;
			t.$store.commit("core/setCloseModal", {});
			t.$parent.close();
		},
		getCompanyInfo() {
			let t = this;
			t.$store.commit("core/setLoadingModal", true);
			window.billing
			.get("companyinfo/" + window.localuserdata)
			.then((response) => {
				console.log("info org actual ", response.data);
				if (response.data.status) {
					t.fullname = response.data[0].bill_firstname+' '+response.data[0].bill_lastname;
					t.emailContact = response.data[0].bill_email;
					t.phoneContact = response.data[0].bill_telephone;
					t.f.signature = t.fullname;
					t.f.emailContact = t.emailContact;
					t.f.phoneContact = t.phoneContact;
				}
				t.getSignature();
			})
			.catch((error) => {
				console.log(error);
				t.$store.commit("core/setLoadingModal", false);
			});
		},
		getSignature() {
			let t = this;
			t.$store.commit("core/setLoadingModal", true);
			window.master.post("getSignature", {
				user_id: window.master_client,
				org_id: window.localorgdata,
			})
			.then((response) => {
				console.log(response.data);
				if(response.data.status){
					t.f.id = response.data.r.id
					let val = JSON.parse(response.data.r.meta_value);
					if(val){
						t.f.signature = val.signature || t.fullname;
						t.f.fontStyle = val.fontStyle || 5;
						t.f.termsConditions = val.termsConditions || t.termsConditionsDefaul;
						t.f.showSign = val.showSign || 0;
						t.f.showSignCustomer = val.showSignCustomer || 0;
						t.f.emailContact = val.emailContact || t.emailContact;
						t.f.phoneContact = val.phoneContact || t.phoneContact;
						t.f.copycostperpage = val.copycostperpage || 0;
					}
				}else{
					t.f.signature = t.fullname;
						t.f.fontStyle = 5;
						t.f.termsConditions = t.termsConditionsDefaul;
						t.f.showSign = 1;
						t.f.showSignCustomer = 0;
						t.f.emailContact = t.emailContact;
						t.f.phoneContact = t.phoneContact;
						t.f.copycostperpage = 0;
				}
				t.$store.commit("core/setLoadingModal", false);
			})
			.catch((error) => {
				console.log(error);
				t.$notify({
					group: "noti",
					type: "error",
					title: "Error",
					text: "Could not save changes",
				});
				t.$store.commit("core/setLoadingModal", false);
			});
		},
		saveSettingSign() {
			let t = this;
			t.$store.commit("core/setLoadingModal", true);
			window.master.post("setSignature", t.f)
			.then((response) => {
				console.log(response.data);
				if(response.data.status){
					t.$notify({
						group: "noti",
						type: "success",
						title: "Success",
						text: "Successfully saved",
					});
				}
				else
				{
					t.$notify({
						group: "noti",
						type: "error",
						title: "Error",
						text: "Could not save changes",
					});
				}
				t.$store.commit("core/setLoadingModal", false);
				t.CancelClose();
			})
			.catch((error) => {
				console.log(error);
				t.$notify({
					group: "noti",
					type: "error",
					title: "Error",
					text: "Could not save changes",
				});
				t.$store.commit("core/setLoadingModal", false);
			});
		},
	},
	watch: { },
	computed: {},
};
</script>
<style lang="css" scoped>
	.buttons{
		margin: 20px 0px;
	}
	.btn{
		margin: 0px 10px;
	}
	.alert-dismissible {
	    padding-right: 30px;
	    font-size: 12px;
	    margin-top: 20px;
	}
	.badge-info:hover{cursor: pointer;}
	#previewSign{
		width: 100%;
		height: 100px;
		border: 1px solid #eee;
		border-radius: 2px;
		text-align: center;
		word-wrap: break-word;
		color: #333;
		font-size: 30px;
		line-height: 1.5;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		align-content: center;
		justify-content: center;
		align-items: center;
		margin: 20px auto;
	}
</style>
